import React, { useEffect, useState } from 'react'
import AdminSidebar from './AdminSidebar';
import AdminHeader from './AdminHeader';
import api from '../../../utils/api';
const base_url= process.env.REACT_APP_API_URL;

const CasinoHistory = () => {
    const [isSidebarOpen, setIsSidebarOpen] = useState(!(window.innerWidth < 768));
    const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
    const [history, setHistory]= useState([]);

    // Toggle sidebar visibility
    const toggleSidebar = () => {
        setIsSidebarOpen(!isSidebarOpen);
      };

    const fethcHistory= async()=> {
        const auth= localStorage.getItem('admin');
        const response= await api.get('/api/webapi/admin/casinoHistory',
            {
                headers:{
                    Accept:'application/json',
                    Authorization:`${auth}`
                }
            }
        )
        // console.log('airh',response);
        const hist= response.data.data;
        // console.log('jiys',hist);
        if(response?.data.success){
            setHistory(hist);
        }
    }

    const handleChange= (e)=> {
        const inputValue= e.target.value;
        
        if (inputValue === "") {
            // Reset to original fetched data when input is cleared
            setHistory(history);
        } else {
            const filterData = history.filter((val) => {
                return val.playerId.includes(inputValue);
            });
    
            setHistory(filterData);
        }
    }

    useEffect(()=>{
      window.scrollTo(0,0);


      fethcHistory();
        // console.log(history);
    },[]);

    useEffect(() => {
    const handleResize = () => {
      const mobile = window.innerWidth < 768;
      setIsMobile(mobile);
      
      // On desktop, sidebar should always be "open"
      if (!mobile) {
        setIsSidebarOpen(true);
      }
    };
    
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

    return (
      <div className="wrapper">
        {/* Main Sidebar */}
        {/* <AdminSidebar 
          isSidebarOpen={isSidebarOpen} 
          toggleSidebar={toggleSidebar} 
          isMobile={isMobile}
        /> */}
        
        {/* Header - Pass mobile info */}
        {/* <AdminHeader 
          toggleSidebar={toggleSidebar} 
          isSidebarOpen={isSidebarOpen}
          isMobile={isMobile}
        /> */}
        
        {/* Content Wrapper - Use conditional class and margin */}
        <div
          className={`content-wrapper d-flex flex-column ${
            !isMobile && isSidebarOpen ? "" : "open-content-wrapper"
          }`}
          style={{
            marginLeft: (!isMobile && isSidebarOpen) ? "" : "0",
            transition: "margin-left 0.3s ease"
          }}
        >
    <section className="content-header">
      <div className="container-fluid">
        <div className="row mb-2">
          <div className="col-sm-6">
            <h1>Casino Bets History</h1>
          </div>
        </div>
      </div>
    </section>
    <div className="container-fluid">
      <div className="card">
        <div className="row">
          <div className="col-md-12">
            <div className='m-3'>
                <input type='text' placeholder='Enter user id to seach' className='form-control'  onChange={handleChange}/>
            </div>
            <div className='mt-4'>
            <table className="table table-responsive-sm">
                <thead>
                    <tr className="p-2">
                        <th className=" text-center text-nowrap">User ID</th>
                        <th className=" text-center text-nowrap">Game Code</th>
                        <th className=" text-center text-nowrap">Game Name</th>
                        {/* <th className=" text-center text-nowrap">Provider Name</th> */}
                        <th className=" text-center text-nowrap">Price</th>
                        <th className=" text-center text-nowrap">Profit/Loss</th>
                        <th className=" text-center text-nowrap">Status</th>
                        <th className=" text-center text-nowrap">Place Date</th>
                    </tr>
                </thead>

                <tbody>
                    {history.map((data)=> (
                        <tr key={data.id}>
                            <td className='text-center'>{data.playerId}</td>
                            <td className='text-center'>{data.gameId}</td>
                            <td className='text-center'>{data.gameCategory}</td>
                            {/* <td className='text-center'>{data.gameProvider}</td> */}
                            <td className='text-center'>{data.amount}</td>
<td
  className={`text-center ${
    data?.status === "lose" ? "text-red" : "text-green"
  }`}
>
  {data?.status === "lose" ? data.amount : data.profit}
</td>
<td className="text-center bb">
  <span
    className="rounded px-2"
    style={{
      background:
        data?.status === "lose"
          ? "rgb(255,0,0)"
          : data?.status === "pending"
          ? "orange"
          : "rgb(3,187,22)",
      color: "#fff",
    }}
  >
    {data?.status === "pending" ? "Rollback" : data?.status}
  </span>
</td>
                            <td className='text-center'>{data.time}</td>
                        </tr>
                    ))}
                </tbody>
            </table>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div className="mb-4" />
    
  </div>
</div>
    )
}

export default CasinoHistory
